import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../components/ui/Accordion';
import pt from '../locales/pt';

const pagePad =
  'px-space-5 py-space-12 mid:px-space-10 mid:py-space-16 wide:px-space-20 wide:py-space-24';

/**
 * FAQ · 375/768/1280 × light/dark — evplanner-gleb-design-system.pen
 */
export function Faq() {
  return (
    <section className={`flex flex-col items-center ${pagePad}`}>
      <div className="flex w-full max-w-3xl flex-col gap-space-10">
        <div className="flex flex-col gap-space-3">
          <span className="type-section text-sage-700 dark:text-sage-300">{pt.faq.eyebrow}</span>
          <h1 className="type-landing-h2">{pt.faq.title}</h1>
        </div>
        <Accordion type="single" collapsible>
          {pt.faq.items.map((item) => (
            <AccordionItem key={item.question} value={item.question}>
              <AccordionTrigger>{item.question}</AccordionTrigger>
              <AccordionContent>{item.answer}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
